import Header from "./Header";
import Footer from './Footer';
export default {
    Header,
    Footer
}